import { render, staticRenderFns } from "./1210_穿过迷宫的最少移动次数.md?vue&type=template&id=4a7bb03a&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports